import { checkIsInternal, getTinGroupId } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { APPEAL_DETAILS_DATA_API_URL, APPEAL_DETAILS_DATA_BULK_API_URL, APPEAL_TOP_OVERTURN_REASON_API_URL, APPEALS_TOP_OVERTURN_REASON_DATA_BULK_API_URL, APPEALS_TREND_DATA_API_URL, APPEALS_TREND_DATA_BULK_API_URL } from './apiUrlConstants';
import { getJobId, queueJobPolling } from '@src/utility/CommonBulkPoll';

const _httpService = new HttpService();
const cache = new Map();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getAppealData= async (payload:any) =>{
    const url = APPEAL_DETAILS_DATA_API_URL;
    let finalUrl = url;

    if (payload?.queryParam && typeof payload.queryParam === 'object') {
        const queryParams = new URLSearchParams(payload.queryParam).toString();
        if (queryParams) {
            finalUrl = `${url}?${queryParams}`;
        }
    }

    try {
        const responseData: any = await _httpService.push(finalUrl, payload?.requestBody);
        return responseData;
    } catch {
        return null;
    }
}

export const getAppealTopReasonData= async (payload:any) =>{
    const isContractIdFlow = sessionStorage.getItem('contractIdNavigation') === 'true';
    const url = !isContractIdFlow && payload?.Tin
        ? `${APPEAL_TOP_OVERTURN_REASON_API_URL}/?request-type=APPEALS_TOP_OVERTURNED_REASON_DOR_TIN`
        : `${APPEAL_TOP_OVERTURN_REASON_API_URL}/?request-type=APPEALS_TOP_OVERTURNED_REASON_DOR_HCO`;
    try {
           const responseData: any = await _httpService.push(url, payload);
                return responseData;
            } catch {
                return null;
            }
}

export const getAppealTredData= async (payload:any) =>{
    const url = payload?.Tin ? `${APPEALS_TREND_DATA_API_URL}/?request-type=APPEALS_SMRY_DOR_TREND_TIN` : `${APPEALS_TREND_DATA_API_URL}/?request-type=APPEALS_SMRY_DOR_TREND_HCO`;
    try {
           const responseData: any = await _httpService.push(url, payload);
                return responseData;
            } catch {
                return null;
            }
}

// Helper for polling a bulk job (same as NonPayment pattern)
type PollBulkJobOptions = { onStop?: (stopFn: () => void) => void };
async function pollBulkJob<T = unknown>(
  endpoint: string,
  payload: Record<string, unknown>,
  options?: PollBulkJobOptions
): Promise<T> {
  const jobIdResponse = await getJobId(endpoint, payload);
  const jobId = jobIdResponse.Data.JobId;
  return new Promise<T>(async (resolve, reject) => {
    const cleanup = await queueJobPolling(
      jobId,
      {
        onInProgress: () => {
},
        onCompleted: (result) => {
resolve(result as T);
        },
        onFailed: (errorMessage) => {
          console.error('[Appeal Bulk Polling] Job failed:', errorMessage);
          reject(new Error(errorMessage));
        },
        onStatusUpdate: (statusResponse) => {
},
      },
      '/job-status/result',
      1000
    );
    // Pass cleanup function to caller if they provided onStop callback
    if (options?.onStop) {
      options.onStop(cleanup);
    }
  });
}

// Bulk polling function for Appeal Details Data
export const getAppealDataBulk = async (
    payload: any,
    options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
    const url = APPEAL_DETAILS_DATA_BULK_API_URL;
    let finalUrl = url;

    if (payload?.queryParam && typeof payload.queryParam === 'object') {
        const queryParams = new URLSearchParams(payload.queryParam).toString();
        if (queryParams) {
            finalUrl = `${url}?${queryParams}`;
        }
    }

    // Add TinGroupId to the payload
    const updatedPayload = {
        TinGroupId: getTinGroupId(),
        ...(payload?.requestBody || payload),
    };

    try {
        // Use the pollBulkJob helper with updated payload
        const result = await pollBulkJob(finalUrl, updatedPayload, options);
        return result;
    } catch (error) {
        console.error('[getAppealDataBulk] Error:', error);
        return null;
    }
};

// Bulk polling function for Appeal Top Reason Data
export const getAppealTopReasonDataBulk = async (
    payload: any,
    options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
    // Bulk flow always uses TIN-based request type, not HCO
    const url = `${APPEALS_TOP_OVERTURN_REASON_DATA_BULK_API_URL}/?request-type=APPEALS_TOP_OVERTURNED_REASON_DOR_TIN`;

    // Add TinGroupId to the payload
    const updatedPayload = {
        TinGroupId: getTinGroupId(),
        ...payload,
    };

    try {
        // Use the pollBulkJob helper with updated payload
        const result = await pollBulkJob(url, updatedPayload, options);
        return result;
    } catch (error) {
        console.error('[getAppealTopReasonDataBulk] Error:', error);
        return null;
    }
};

// Bulk polling function for Appeal Trend Data
export const getAppealTrendDataBulk = async (
    payload: any,
    options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
    // Bulk flow always uses TIN-based request type, not HCO
    const url = `${APPEALS_TREND_DATA_BULK_API_URL}?request-type=APPEALS_SMRY_DOR_TREND_TIN`;

    // Add TinGroupId to the payload
    const updatedPayload = {
        TinGroupId: getTinGroupId(),
        ...payload,
    };

    try {
        // Use the pollBulkJob helper with updated payload
        const result = await pollBulkJob(url, updatedPayload, options);
        return result;
    } catch (error) {
        console.error('[getAppealTrendDataBulk] Error:', error);
        return null;
    }
};